import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const RSVInChildren = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding6rem1 right-padding6rem1 py-4 py-md-4 py-lg-5 ptop-bottom2rem1' style={{ backgroundImage:"url('rsv-testing/ULC-Testing-bg-v1.png')", height:'100%', width:'100%'}}>
            <div className=''>
                <Row className='reverse-section py-lg-4'>
                    <Col sm='12' md='12' lg='6' className=''>
                        <div className='pt-md-5 pt-4 d-sm-flex justify-content-sm-center justify-content-lg-start'>
                            <img src='rsv-testing/RSV-in-Children-v1.png' alt='testing' className='img-w8' height='%' width='%' />
                        </div>
                    </Col>
                    <Col sm='12' md='12' lg='6' className=''>
                        <div className=''>
                            <div className='pb-3'>
                                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                                    RSV IN CHILDREN
                                </div>
                                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                            </div>

                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            Infants and toddlers can be at risk from the Respiratory Syncytial Virus (RSV), which mimics mild cold symptoms. The respiratory syncytial virus, or RSV for kids, is a prevalent and highly contagious virus that most children will contract at least once before age two. Thankfully, most cases show mild symptoms and can be treated at home with rest and regular fluids, but some children can become extremely ill and have difficulty breathing. In such case, visit your nearest hospital or have your child tested for RSV in Chicago.
                            </div>

                            <div className='pt-4'>
                            <Link to='/book-panel-test-appointment' className='text-white text-hoverblack text-montserrat fw-700 fs-ss-16' style={{ textDecoration:'none'}}>
                            <Button className='btn-ss-secondary rounded20 fw-600' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                            <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'10px 10px',}}>BOOK YOUR RSV TEST</text></Button></Link>
                            {/* <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                            </Button> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

    </div>
  )
}

export default RSVInChildren